import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.192 6.808A13 13 0 0 0 8.026 5.733l-.26.207-.253.213a13 13 0 0 0-3.017 15.9l.107.196-1.069 3.744-.04.162a2 2 0 0 0 .549 1.802l.123.113.13.101a2 2 0 0 0 1.711.295l3.742-1.07.198.108.293.15A13 13 0 0 0 25.192 6.808m-15.94.505a11 11 0 0 1 15.435 15.434l-.188.236-.197.233A11 11 0 0 1 10.65 25.61l-.329-.188-.108-.046a1 1 0 0 0-.61-.018l-4.146 1.185 1.185-4.147.028-.133a1 1 0 0 0-.13-.652A11 11 0 0 1 9.253 7.313M16 21a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m4.5-7.5a4.5 4.5 0 1 0-9 0 1 1 0 1 0 2 0l.005-.164A2.5 2.5 0 1 1 16 16.001a1 1 0 0 0-1 1v1l.007.116a1 1 0 0 0 .993.884l.117-.007A1 1 0 0 0 17 18l-.001-.113.237-.06a4.5 4.5 0 0 0 3.264-4.327"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconRfIs = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRfIs);
export default Memo;
